import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main" }

import {
  GetCardHeight,
  MainTitle,
  IntroductionCard,
  ServiceCardSlider,
  DownloadDocument,
} from "../../components/main";
import { useDisplay } from "vuetify";

import "swiper/css";
import "swiper/css/pagination";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(GetCardHeight)),
    _createVNode(_unref(MainTitle)),
    _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer, {
          class: _normalizeClass({ 'py-4': _unref(xs), 'py-6': _unref(smAndUp) })
        }, null, 8, ["class"]),
        _createVNode(_unref(IntroductionCard)),
        _createVNode(_component_v_spacer, {
          class: _normalizeClass({ 'py-8': _unref(xs), 'py-12': _unref(smAndUp) })
        }, null, 8, ["class"]),
        _createVNode(_unref(ServiceCardSlider))
      ]),
      _: 1
    }),
    _createVNode(_unref(DownloadDocument))
  ]))
}
}

})